import { render, staticRenderFns } from "./DiscardChanges.vue?vue&type=template&id=2cbdc801&scoped=true&"
import script from "./DiscardChanges.vue?vue&type=script&lang=js&"
export * from "./DiscardChanges.vue?vue&type=script&lang=js&"
import style0 from "./DiscardChanges.vue?vue&type=style&index=0&id=2cbdc801&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbdc801",
  null
  
)

export default component.exports